var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"get_code_but_box",on:{"click":_vm.getCOdeEvent}},[_vm._t("default",function(){return [_c('div',{staticClass:"geit_code_icon",class:{ cantrue: _vm.codeButClor }},[_vm._v(" "+_vm._s(_vm.getCOdeBut)+" ")])]},{"info":{ canDo: _vm.codeButClor, text: _vm.getCOdeBut }})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }